import {
  PAGE_TAB_PARAM,
  CHAMP_PANEL_PARAMS,
  CUSTOMER_PANEL_PARAMS,
  parsePositiveId,
  useProfilePanelParams,
  useProfileTabParam,
} from "../profile/panel-params";

/**
 * The champ panel lives in the URL — `?champ=<id>` and, for the tab,
 * `&htab=activity` — the twin of the customer panel's `?customer=` / `ctab`
 * (see `../customers/customer-panel-params.ts`). The full page `/champs/:id`
 * uses its own `ptab`. Opening a champ closes a customer panel and the other
 * way round, as a new history entry.
 */
export const CHAMP_PARAM = CHAMP_PANEL_PARAMS.param;
export const CHAMP_TAB_PARAM = CHAMP_PANEL_PARAMS.tabParam;

export const CHAMP_TABS = [
  "overview",
  "activity",
  "jobs",
  "customers",
  "tickets",
  "whatsapp",
  "calls",
] as const;
export type ChampTab = (typeof CHAMP_TABS)[number];

export const parseChampId = parsePositiveId;

export function parseChampTab(value: string | null): ChampTab | null {
  return (CHAMP_TABS as readonly string[]).includes(value ?? "")
    ? (value as ChampTab)
    : null;
}

export function useChampPanel() {
  const { id, tab, open, close } = useProfilePanelParams<ChampTab>(
    CHAMP_PANEL_PARAMS,
    CUSTOMER_PANEL_PARAMS,
    parseChampTab,
  );
  return { champId: id, tab, open, close };
}

/** The tab on the full page (`/champs/:id`), which has no `champ` param. */
export function useChampTabParam() {
  return useProfileTabParam<ChampTab>(PAGE_TAB_PARAM, parseChampTab);
}
